import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Tooltip } from "./Tooltip.js";
import { token } from "./token.js";
import { textStyles } from "./textStyles.js";
import { warnInDev } from "./warnInDev.js";
function StatsItem({
  icon,
  children,
  title,
  ...props
}) {
  if (children && children.toString().length > 3) {
    warnInDev("Stat value can't be longer than 3 characters");
  }
  return /* @__PURE__ */ jsx(Tooltip, {
    content: title,
    timing: "delay",
    children: (triggerProps) => /* @__PURE__ */ jsxs(StatItemStyled, {
      ...props,
      ...triggerProps,
      children: [/* @__PURE__ */ jsx("div", {
        children: icon
      }), children ? /* @__PURE__ */ jsx("span", {
        children
      }) : null]
    })
  });
}
const StatItemStyled = styled.div.withConfig({
  displayName: "StatItemStyled",
  componentId: "sc-7uwt82-0"
})(["", " display:flex;align-items:center;color:", ";column-gap:", ";"], textStyles.uiTextS, token.colorTextMuted, token.spacing2);
export {
  StatsItem
};
//# sourceMappingURL=StatsItem.js.map
